import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getPublicClinicBookingUrl } from "@/utils/publicSiteUrl";
import { FullScreenLoader } from "@/shared/ui/components/FullScreenLoader";

/** Sends app-subdomain /p/:slug traffic to the public marketing host (canonical for SEO). */
export function PublicClinicSubdomainRedirect() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    if (!slug) return;
    window.location.replace(getPublicClinicBookingUrl(slug));
  }, [slug]);

  return <FullScreenLoader />;
}
